import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'
import { kFormatter } from 'helpers/formatters'

import classes from './ReviewsNum.module.scss'

/** @type {import('./types').default} */
const ReviewsNum = ({ className, reviewsNum, xs = false }) => {
  return (
    <Typography className={clsx('ReviewsNum', classes.reviewsNum, { [classes.xs]: xs }, className)}>
      <span className={reviewsNum > 0 ? classes.noLink : classes.zeroReviews}>({kFormatter(reviewsNum)})</span>
    </Typography>
  )
}

export default ReviewsNum
